import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'ui/shared/containers';
import './TermsOfServiceDialog.css';

const tos = {
    en: require('lang/en/tos.txt'),
    fr: require('lang/fr/tos.txt'),
    it: require('lang/it/tos.txt'),
} as any;

export type Props = {
    visible: boolean;
    onClickClose: MouseEventHandler<HTMLElement>;
};

export const TermsOfServiceDialog = ({ visible, onClickClose }: Props) => {
    const { t, i18n } = useTranslation();
    return (
        <Dialog
            id="terms-of-service"
            titleKey={ 'LOGIN.TERMS_OF_SERVICE' }
            visible={ visible }
        >
            <iframe src={ tos[i18n.language] || tos['en'] } title={ t('LOGIN.TERMS_OF_SERVICE') }/>
            <button className="ui primary submit button" type="button" onClick={ onClickClose }>
                <div className="visible content">{ t('COMMAND.CLOSE') }</div>
            </button>
        </Dialog>
    );
};
